import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { TranscriptVersion } from "../store/state/story_authoring/reducer";
import type { BaseSlateParagraph } from "../components/utils/types";
import type { RootState } from "../store/state/rootReducer";
import { convertDpeToSlate } from "../components/utils/conversions";

const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const baseUrl = (api.getState() as RootState).config.apiUrl;
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const jwtToken = (getState() as RootState).auth.token;
      if (jwtToken) {
        headers.set("Authorization", jwtToken);
      }
      return headers;
    },
  });
  return rawBaseQuery(args, api, extraOptions);
};

export const theirStoryAPI = createApi({
  reducerPath: "theirStoryAPI",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["TranscriptVersions"],
  endpoints: (builder) => ({
    getTranscriptVersions: builder.query<any, string>({
      query: (storyId) => ({ url: `/transcripts/${storyId}/versions` }),
      providesTags: ["TranscriptVersions"],
    }),
    getTranscriptVersion: builder.query<BaseSlateParagraph[], { storyId: string; version: TranscriptVersion }>({
      query: ({ storyId, version }) => {
        const filename = version?.file?.split("/")[version.file.split("/").length - 1];
        return { url: `/transcripts/${storyId}/version/file/${filename}` };
      },
      transformResponse(response: { transcript: any }) {
        return convertDpeToSlate(response?.transcript) || [];
      },
    }),
  }),
});

export const { useGetTranscriptVersionsQuery, useGetTranscriptVersionQuery } = theirStoryAPI;
